angular.module("AccountingBoxApp").config(function($stateProvider) {
  $stateProvider
    .state("app.company.sale", {
      abstract: true,
      template: "<ui-view/>",
      url: "/sale"
    })
    .state('app.company.sale.page', {
      url: '*path',
      template: "<ui-view/>",
    })
    .state('app.company.sale.invoices', {
      url: '/invoices',
      template: "<ui-view/>",
    })
    .state('app.company.sale.recurringInvoices', {
      url: '/recurring-invoices',
      template: "<ui-view/>",
    })
    .state('app.company.sale.invoiceSettings', {
      url: '/invoice-settings',
      template: "<ui-view/>",
    })
    .state('app.company.sale.items', {
      url: '/items',
      template: "<ui-view/>",
    })
    .state("app.company.edit.sales", {
      url: "/verkopen/:id/bewerk",
      templateUrl: "app/sales/edit/edit.html",
      controller: "SalesEditCtrl",
      controllerAs: "e",
      params: {
        sale: null
      }
    })
    .state("app.company.new.sales", {
      url: "/verkopen/nieuw/:id",
      templateUrl: "app/sales/edit/edit.html",
      controller: "SalesEditCtrl",
      controllerAs: "e",
      params: {
        attachment: null
      }
    })
    // .state("app.company.sales.list", {
    //   url: "",
    //   templateUrl: "app/sales/list/list.html",
    //   controller: "SalesListCtrl",
    //   controllerAs: "l"
    // })
    .state("app.company.sales.view", {
      url: "/:id/bekijk",
      templateUrl: "app/sales/view/view.html",
      controller: "SalesViewCtrl",
      controllerAs: "v"
    });
});
